import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Services from './pages/Services';
import About from './pages/About';
import Contact from './pages/Contact/Contact';
import Technologies from './pages/Technologies';
import SoftwareDevelopment from './pages/Services/SoftwareDevelopment';
import MobileApps from './pages/Services/MobileApps';
import WebDev from './pages/Services/WebDev/WebDev';
import AIAutomation from './pages/Services/AIAutomation';
import CloudSolutions from './pages/Services/CloudSolutions/CloudSolutions';
import UIUXDesign from './pages/Services/UIUXDesign/UIUXDesign';
import TechnologyStack from './pages/Technologies/TechnologyDetail/TechnologyStack';
import ScrollToTop from './components/ScrollToTop';
import FAQ from './pages/FAQ';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <ScrollToTop />
        <div className="App">
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services/software-development" element={<SoftwareDevelopment />} />
            <Route path="/services/mobile-apps" element={<MobileApps />} />
            <Route path="/services/web-development" element={<WebDev />} />
            <Route path="/services/ai-automation" element={<AIAutomation />} />
            <Route path="/services/cloud-solutions" element={<CloudSolutions />} />
            <Route path="/services/ui-ux-design" element={<UIUXDesign />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/technology" element={<Technologies />} />
            <Route path="/technologies/stack" element={<TechnologyStack />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
          </Routes>
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;
